import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { paths } from '@/core/router/paths';
import { useClearClientAuthData } from '@/features/Auth/_utils/useClearClientAuthData';
import { useSignOutMutation } from '@/features/Header/_graphql/mutation/SignOut.hook';

import { getIsOnAuth2Path } from '../utils/getIsOnAuth2Path';

/**
 * Using the `signOut` mutation logges the user out of the application - it clears any user data stored on the client and invalidates the refresh token cookie.
 * It should only be used as a direct CTA by the user (e.g. clicking on the "Logout" button).
 */
export const useSignOut = () => {
	const [signOut] = useSignOutMutation();
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const { clearClientAuthData } = useClearClientAuthData();

	const handleSignOut = useCallback(async () => {
		const isOutsideAuthPaths = !getIsOnAuth2Path(pathname);

		if (isOutsideAuthPaths) {
			try {
				await signOut();
				clearClientAuthData();
				navigate(paths.login);
			} catch (e) {
				console.error('Sign out failed:', e);
			}
		}
	}, [pathname, signOut, clearClientAuthData, navigate]);

	return { handleSignOut };
};
